import { inject, Type } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { from } from 'rxjs';
import { concatMap, last, takeWhile } from 'rxjs/operators';

import { CanActivateAsync } from './types';

export function queueCanActivate(
  guards: Type<CanActivateAsync>[],
): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const initGuards = guards.map((guard) => inject(guard));
    return from(initGuards).pipe(
      concatMap((guard: CanActivateAsync) => guard.canActivate(route, state)),
      takeWhile((canActivate) => canActivate === true, true),
      last(),
    );
  };
}
